import { signal } from '@preact/signals';
import { MemberType } from '../config/members';

export const currentMemberPageSignal = signal<MemberType | null>(null);
